<template>
	<div v-if="numOfUnreadAlerts > 0" class="nav-pending-alerts flex-centerize" :class="{ pad_alerts: pad, minimized: minimized }">
		<h5 class="nav-pending-alerts-text">{{ numOfUnreadAlerts }}</h5>
	</div>
</template>

<script>
import { STATIC_INBOXES_IDS } from '@/components/Inbox/inbox.const.js';
import { useAmountOfUnreadAlertsPerInboxId } from '@/store/modules/alerts/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'AppPendingAlerts',
	props: {
		pad: { type: Boolean, default: false },
		minimized: { type: Boolean, default: false },
	},
	computed: {
		...mapGettersShorthand({ useAmountOfUnreadAlertsPerInboxId }),
		numOfUnreadAlerts() {
			return this.useAmountOfUnreadAlertsPerInboxId(STATIC_INBOXES_IDS.ALL_INBOX_ID);
		},
	},
};
</script>

<style scoped lang="scss">
.nav-pending-alerts {
	width: 30px;
	height: 20px;
	border-radius: 9px;
	&.minimized {
		width: 18px;
		height: 18px;
		border-radius: 50%;
	}
	background-color: #fe2b78;
	&.pad_alerts {
		margin-left: 5.5px;
	}

	.nav-pending-alerts-text {
		color: var(--white);
	}
}
</style>
